import React, { useState, useRef, useEffect } from 'react';
import './App.css';
import Fingerprint2 from 'fingerprintjs2';
import { API_URL } from './config';

const ChatInput = React.forwardRef(({onSendMessage}, ref) => {
  
  const [messages, setMessages] = useState([]);
  const [fingerprintOwn, setFingerprint] = useState("");
  const [productTypeOwn, setProductType] = useState("");
  const [inputText, setInputText] = useState('');
  const [isTextareaDisabled, setIsTextareaDisabled] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const textareaRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const restorMessage = (message, bUser, answer ) => {
    setMessages(prevMessages => [...prevMessages, { text: message, isUser: bUser, answer: answer }]);
  };

  /*
   * 失去焦点
  */
  const handleBlur = () => {
    setIsFocused(false);
    //console.log('Textarea is blurred');
  };

  const enableInput = () => {
    setIsTextareaDisabled(false);
    setIsButtonDisabled(false);
     // 设置焦点到<textarea>
    if (textareaRef.current) {
      textareaRef.current.readOnly = false;
      //textareaRef.current.focus();
    }
  };

  const disableInput = () => {
    setIsTextareaDisabled(true);
    setIsButtonDisabled(true);
  };

  async function getFingerprint2() {
  return new Promise((resolve) => {
    Fingerprint2.get(function(components) {
      const fingerprintTmp = Fingerprint2.x64hash128(
        components.map(pair => pair.value).join(), 
        31
      );
      console.log('Device Fingerprint:', fingerprintTmp);
      setFingerprint(fingerprintTmp); // 如果你需要这个副作用
      resolve(fingerprintTmp); // 这才是真正的返回
    });
  });
}

  const adjustHeight = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      if(inputText.length < 30){
        textarea.style.height = "48px"; // 先重置高度
      }else{
        textarea.style.height = "auto"; // 先重置高度
        textarea.style.height = `${textarea.scrollHeight}px`; // 根据内容调整高度
      }
    }
  };

  useEffect(() => {
    // 在组件渲染后，如果textarea不可用，则不设置焦点
    if (!isTextareaDisabled && textareaRef.current) {
      textareaRef.current.readOnly = false;
      //.current.focus();
    }
    getFingerprint2 ();
    adjustHeight();
    const queryParams = new URLSearchParams(window.location.search);
    const param = queryParams.get("param");
    const productType0 = queryParams.get("productType");
    console.log("param: " + param, "productType: " + productType0);
    setProductType(productType0);
  }, [isTextareaDisabled, productTypeOwn]);

  const handleInputChange = (e) => {
    setInputText(e.target.value);
    if(e.target.value.length > 30){
      e.target.style.height = 'auto'; // 重置高度以便重新计算
      e.target.style.height = `${e.target.scrollHeight}px`; // 设置高度为滚动高度
    }
    else{
      e.target.style.height = '48px';
    }
  };

  function callbackLogin(json) {
    try {
      let obj = window.JSON.parse(json);
      console.log(obj)
      if (obj.code === 200) {
        const dataReturnStr = obj.data
        console.log(dataReturnStr)
        //console.log(id)
        restorMessage(dataReturnStr, false, obj.data);
        onSendMessage( dataReturnStr, false, false, obj.data);
      }
      else{
        console.log("error")
        onSendMessage(obj.msg.referAnswer, false, true);
        setMessages([])
      }
    } catch (error) {
      // 如果上面的操作抛出异常，这里的代码将会执行
      console.error('Error during data fetching:', error);
      onSendMessage("AI\n Error during data fetching:" + error, false, true);
    }
    enableInput()
  };

  const handleSendPost = async (paramBody, messageAll,fingerprint, callback, strType = "") =>
  {
    let strData = {
			question: paramBody,
      userFeature: fingerprint,
      productType: productTypeOwn,
		};
    if(strType !== ""){
      strData.productType = strType;
    }
    console.log('fingerprint 222333: ' + fingerprint , productTypeOwn);
    let httpRequest = new XMLHttpRequest();
    httpRequest.open('POST', `${API_URL}/getAnswer`, true);
    httpRequest.setRequestHeader("Accept", "application/json");
    httpRequest.setRequestHeader("Content-type", "application/json");
    let json = JSON.stringify(strData)
    console.log("json: " + json)
    httpRequest.send(json);

    httpRequest.onreadystatechange = function () {//
      if (httpRequest.readyState === 4) {
        if (httpRequest.status === 200) {
          let jsonResponse = httpRequest.responseText;
          callback(jsonResponse);
        } else {
          console.error(`Request failed with status: ${httpRequest.status}, response: ${httpRequest.responseText}`);
          
        }
      }
    };
  }

  const handleSendMessage = () => {
    if (inputText.trim() !== '') {
      restorMessage(inputText, true);
      onSendMessage(inputText, true);
      setInputText('');
      let lastFourMessages = messages;
      if (messages.length >= 7){
        lastFourMessages = messages.slice(-2);
      }
      
      let messageAll = ""
      lastFourMessages.map((msg, index) => (
        messageAll += msg.text +"\n"
      ))
      handleSendPost(inputText, messageAll, fingerprintOwn, callbackLogin)
      disableInput()
    }
  };

  const ParentHandleSendMessage = (inputValue, productType0) => {
    setProductType(productType0);
    getFingerprint2 ()
    .then(fingerprint => {
      console.log("parent call", productType0, fingerprint)
      if (inputValue.trim() !== '') {
        restorMessage(inputValue, true);
        onSendMessage(inputValue, true);
        setInputText('');
        let lastFourMessages = messages;
        if (messages.length >= 7){
          lastFourMessages = messages.slice(-2);
        }
        
        let messageAll = ""
        lastFourMessages.map((msg, index) => (
          messageAll += msg.text +"\n"
        ))
        handleSendPost(inputValue, messageAll, fingerprint, callbackLogin, productType0)
        disableInput()
      }
    })
    .catch(error => {
      console.error("Error:", error);
    });
    
  };

  // 将子组件中的函数通过 ref 暴露给父组件
  React.useImperativeHandle(ref, () => ({
    ParentHandleSendMessage
  }));

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // 阻止默认的 Enter 键行为（比如换行）
      handleSendMessage();
      e.target.style.height = '48px';
    }
  };

  const [btnStyle, setBtnStyle] = useState({
    width: '100px',
    height: '30px',
    marginLeft: '20px',
    borderRadius: '8px'
  });

  return (
    <div className="chat-input-out">
      <div className="chat-input">
      <div className="text-container">
        <textarea className='textarea-css'
          //disabled={isTextareaDisabled}
          cols="100"
          ref={textareaRef}
          placeholder="请输入您的问题..."
          value={inputText}
          onKeyDown={handleKeyDown}
          onChange={handleInputChange}
                  onBlur={handleBlur}
                  // onFocus={handleFocus}
        />

        <button  className='send-button'
          onClick={handleSendMessage}
          //disabled={isButtonDisabled}
          >
        </button>
        </div>
      </div>
    </div>
  );
});

export default ChatInput;
